module.exports = __webpack_public_path__ + "static/media/sf-test-6.818846e1.mp3";